import * as React from 'react';

import { Box, Flex, H2, Image, Text } from '@opendoor/bricks/core';

interface IHeadingSectionProps {
  heading: string;
  description: string;
  imgUrl: string;
}

export const HeadingSection: React.FC<IHeadingSectionProps> = ({
  description,
  imgUrl,
  heading,
}) => {
  return (
    <>
      <Box width={['150px', null, '200px']} mx="auto" marginBottom={[0, 0, 9]}>
        <Image height="120px" width="120px" src={imgUrl} alt="" />
      </Box>
      <Flex
        flexDirection="column"
        alignItems={['flex-start', 'center']}
        width="100%"
        paddingBottom={[8, 8, 0]}
      >
        <H2 marginBottom={7} fontSize={['s3', 'UNSAFE_h2']}>
          {heading}
        </H2>
        <Text fontSize="s1" textAlign={['left', 'center']} marginBottom={[0, 11]}>
          {description}
        </Text>
      </Flex>
    </>
  );
};
